/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SalesbyCategoryRoutingModule
 * Purpose		: Routing module for SalesbyCategory.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SalesbyCategoryListComponent } from './SalesbyCategoryList.component';
import { SalesbyCategoryDetailsComponent } from './SalesbyCategoryDetails.component';

const SalesbyCategoryRoutes: Routes = [
	{ path: 'SalesbyCategory',  component: SalesbyCategoryListComponent },
	{ path: 'SalesbyCategory/Details/:id', component: SalesbyCategoryDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(SalesbyCategoryRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class SalesbyCategoryRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SalesbyCategory/SalesbyCategory-routing.module.ts